



























import Vue from "vue";
import BarChart from "../../../components/black_dashboard_pro/Charts/BarChart";
import config from "../../../config";
import * as chartConfigs from "../../../components/black_dashboard_pro/Charts/config";
import HttpClient from "../../../services/HttpClient";
import HttpClientFactory from "../../../services/HttpClientFactory";
import moment from "moment";
import MonthlyInvoicedAmountsResponse from "../../../types/metrics/api/MonthlyInvoicedAmountsResponse";
import currency from "currency.js";

export default Vue.extend({
  components: {
    BarChart,
  },
  data() {
    return {
      httpClient: {} as HttpClient,
      isChartDataLoaded: false,
      chartData: {
        labels: [] as string[],
        datasets: [
          {
            label: "TOTAL",
            fill: true,
            borderColor: config.colors.mandaa,
            borderWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0,
            data: [] as number[],
          },
        ],
      },
      extraOptions: chartConfigs.barChartOptionsGradient,
      gradientColors: config.colors.blueGradient,
      gradientStops: [1, 0],
    };
  },
  async created() {
    this.httpClient = HttpClientFactory.getInstance();
    await this.getCurrentMonthSummary();
  },
  methods: {
    async getCurrentMonthSummary() {
      const startMonth = moment()
        .startOf("month")
        .subtract(5, "months")
        .format("YYYY-MM")
        .toString();

      const endMonth = moment()
        .endOf("month")
        .format("YYYY-MM")
        .toString();

      const months = {
        startMonth,
        endMonth,
      };
      try {
        const res = await this.httpClient.post(
          process.env.VUE_APP_BACKEND_ENDPOINT +
            "/metrics/v1/invoice/monthly-invoiced-amounts",
          months
        );
        const invoicedAmounts: MonthlyInvoicedAmountsResponse[] = res.data;
        invoicedAmounts.map((invoicedAmount) => {
          const amounts = currency(invoicedAmount.amount, {
            fromCents: true,
            precision: 2,
          }).value;

          this.chartData.labels.push(invoicedAmount.month);

          this.chartData.datasets[0].data.push(amounts);
        });

        this.isChartDataLoaded = true;
      } catch (e) {
        const error: any = {
          text: this.$t("invoices:error"),
          type: "error",
        };
        this.$notify(error);
      }
    },
  },
});
